import script from "./Setup2faPhoneView.vue?vue&type=script&setup=true&lang=js"
export * from "./Setup2faPhoneView.vue?vue&type=script&setup=true&lang=js"

import "./Setup2faPhoneView.vue?vue&type=style&index=0&id=3244caf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3244caf6"]])

export default __exports__